<template>
  <v-custom-swiper :total_num='gallery.length' :page_num="currentPageNum" :itemSize="{width:84,marginRight:20}"   class="slideVertical" ref="pageinationSwiper" >
    <div class="slideWrap">
      <div
        class="slideContainer"
      >
        <div
          class="slideItem"
          v-for="( item, index ) in gallery"
          :key="item.ID"
          :class=" currentIndex==index ? 'imageActive main_button_boder' : ''"
          @click="selectImg(item.ID)"
        >
          <i
            v-if="item.media_content_type === 'video' || item.media_content_type === 'external_video'"
            class="slideItem__video-icon"
            :class="{
              'el-icon-video-play': item.media_content_type === 'video',
              'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
            }"
          ></i>
          <v-img-card :data_src="item.thumbnail" :data_url="item.url" alt="" card_type="square"></v-img-card>
        </div>
      </div>
    </div>
  </v-custom-swiper>
</template>
<script>
import vCustomSwiper from "@/js/components/common/buttonCustomSwiper.vue"
import vImgCard from '@/js/components/common/imgCard.vue';
export default {
  props: {
    gallery: {
      type: Array,
      require: true,
    },
    offsetBottom: {
      type: Number,
      default: 10,
    },
    slidesView: {
      type: Number,
      default: 5,
    },
    slideHeight: {
      type: Number,
      default: 500,
    },
    currentIndex:{
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      count: 0,
      currentPageNum:0
    }
  },
  mounted() {
    let getCurrentPageNum = this.debounce(() => {
      this.currentPageNum = ((this.$refs.pageinationSwiper.$el.offsetWidth-60)/84)
    }, 200);
    getCurrentPageNum();
    window.addEventListener("resize", getCurrentPageNum);
  },
  methods: {
    selectImg(ID) {
      this.$store.dispatch('change_feature_image_id', ID)
    },
  },
  components: {
    vCustomSwiper,
    vImgCard,
  },
  watch: {
    '$store.state.feature_image_id'() {
      this.gallery.some((item, index) => {
        if (item.ID == this.$store.state.feature_image_id) {
          if (index - this.slidesView < 0) {
            this.count = 0
            console.log(this.count, 0)
          } else if (index + this.slidesView > this.gallery.length) {
            this.count = this.gallery.length - this.slidesView
            console.log(this.count, 1)
          } else {
            this.count = index
          }
        }
      })
    },
    // currentIndex(newVal,oldVal){
    //   let sw = this.$('.slideContainer')[0].scrollWidth
    //   let cw = this.$('.slideContainer')[0].clientWidth
    //   if(newVal*84 >= cw/2){
    //     this.$('.slideContainer').css({transform: `translateX(-${(newVal*84/cw)*100 - 40}%)`,})
    //   }else{
    //     this.$('.slideContainer').css({transform: `translateX(-0%)`,})
    //   }

    // }
  },
}
</script>
<style scoped lang='scss'>
.slideVertical {
  margin-top: 20px;
  position: relative;
  overflow: hidden;
  &::v-deep{
    .navigation{
      button{
        top: 20% !important;
        background: rgba(255, 255, 255, 0) !important;
        box-shadow: none !important;
        color: #000000;
        height: 30px;
        width: 30px;
        line-height: normal;
      }
      .custom-swiper-next{
        right: 0 !important;
      }
      .custom-swiper-prev{
        left: 0 !important;
      }
    }
    .custom-swiper{
      width: calc(100% - 60px);
      margin: 0 30px;
    }
  }
  .slideWrap {
    .slideContainer {
      transition: all 0.5s;
      display: -webkit-box;
      .slideItem {
        float: left;
        height: 64px;
        width: 64px;
        position: relative;
        margin-right: 20px;
        cursor: pointer;
        &__video-icon {
          position: absolute;
          z-index: 2;
          font-size: 30px;
          color: #fff;
          height: 100%;
          width: 100%;
          background: #00000035;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img {
          max-height: 100%;
          width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .slideItem:last-child{
        margin-bottom: 0 !important;
      }
      .imageActive {
        .imgCard{
          border: 1px solid  var(--main-btn-bg) !important;
        }
      }
    }
  }
}
</style>
